import layout from '@/layouts/NED-0534-got-show-matcher.vue'
import importAllImages from '@/functions/importAllImages.js'
import header from './header.json'
import parts from './parts.json'
import themes from './themes.json'
import buttonValues from './button-values.json'


export default {
  version: 0, // * used to track minor version revisions
  // Controls the layout component to use
  layout,
  showDump: false,
  custom: {},
  analytics: {
    id: 'UA-71249554-3',
  },

  // Options to control the layout/app - Not implemented in all apps
  // Can be seen in showbags/player ratings where options for sorting/fitering are passed in
  options: {},

  // !! WARNING !!
  // This function imports all images, regardless of whether they are used or not
  // be sure to move unused images to a different location
  allImages: importAllImages(require.context('../../../images', false, /\.js/)),
  backgroundTile: 'scales-blue-dark-tile',

  // Main title/intro content - all items are optional
  header,

  // Array of objects, itterated over to fill out list-like content
  // Requirements of each object are typically governed by the layout/components
  parts,
  themes,
  buttonValues,
  messages: {
    start: 'Choose at least one theme to get started',
  },
}



// WEBPACK FOOTER //
// ./src/content/projects/2019/NED-0534-got-show-matcher/index.js